/**
 * Router Class
 */
export default class Router {


    /**
     * constructor
     */
    constructor() {
        this.oldHash = '';
    }


    /**
     * update event
     */
    updateEvent() {
        let vm = this;
        let event = new CustomEvent("router", {
            "detail": {
                path: window.location.hash,
                previousPath: vm.oldHash
            }
        });
        window.dispatchEvent(event);
    }


    /**
     * get the route
     * @returns {string}
     */
    getRoute() {
        return window.location.hash.replace('#!/', '');
    }


    /**
     * set the route
     *
     * @param param
     * @param updateListener
     */
    setRoute(param, updateListener = false) {
        this.oldHash = window.location.hash;
        window.location.hash = '!/' + param;
        if (updateListener) {
            this.updateEvent();
        }
    }

}


